import { render, staticRenderFns } from "./journey-email-step-content-widget.vue?vue&type=template&id=ed9bae98&scoped=true&"
import script from "./journey-email-step-content-widget.vue?vue&type=script&lang=js&"
export * from "./journey-email-step-content-widget.vue?vue&type=script&lang=js&"
import style0 from "./journey-email-step-content-widget.vue?vue&type=style&index=0&id=ed9bae98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed9bae98",
  null
  
)

export default component.exports